import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { labelSty, styInput } from "./styles-input";
import { SelectInputPropsType } from "../../interface/inputs";
import { styled } from "@mui/material/styles";


// Styled components
export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  // Add any custom styles for FormControl here
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  // Add your customInput styles here
  // For example:
  backgroundColor: "#f5f7f9",
  borderRadius: "8px",
  "& .MuiSelect-select": {
    backgroundColor: "#f5f7f9",
    color: "#000",
    fontSizr: "12px",
    borderRadius: "8px", // Adjust this value as needed
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.black
  // Add any other custom styles for MenuItem here
}));

export default function SelectInput({
  value,
  onChange,
  options,
}: SelectInputPropsType) {
  const theme = useTheme();
  return (
    <Box sx={{ width: "100%" }}>
      <StyledFormControl sx={{ width: "100%" }}>
        <StyledSelect
          value={value ?? ""}
          onChange={onChange}
          sx={{ width: "100%", ...styInput }}
        >
          {options?.map((val, id) => (
            <StyledMenuItem key={id} value={val.value}>
              {val.label}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </StyledFormControl>
    </Box>
  );
}
